import React from 'react';
import { Page, Document, StyleSheet, View, Text } from '@react-pdf/renderer';
import HeaderSection from './pdf-header-footer/header-section';
import FooterSection from './pdf-header-footer/footer-section';
import ProjectInfo from './project-info/project-info';
import { RationValWidth } from './fonts/font';
import DisplayArgoTables from './waterQuality';

// Styles for the PDF document
const styles = StyleSheet.create({
  page: {
    lineHeight: 1.5,
    paddingBottom: RationValWidth(124),
  },
  body: {
    marginHorizontal: RationValWidth(56),
  }
});

// Main component to generate a PDF report
const ArgoReport = ({ svgData, project_details }) => {
  // Check if the main data object is present
  if (!svgData) {
    return (
      <Document>
        <Page size='A4' object-fit='fill'>
          <HeaderSection version='' />
          <View style={styles.body}>
            <Text>No data available to display the report.</Text>
          </View>
          <FooterSection blank='empty' version='' />
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      {/* Render ProjectInfo page if 'Treatment and Summary' and other necessary data are available */}
      {
        // Check if 'Treatment and Summary' is available and provide fallbacks for optional data
        // invoiceData['Treatment and Summary'] && (
        <Page size='A4' object-fit='fill' style={styles.page} bookmark='Preface'>
          <View style={styles.body}>
            <ProjectInfo
              pageWidth={1140}
              svgData={svgData.slice(0, 3) || []} // Pass the first 3 items of svgData to ProjectInfo
            />
          </View>
        </Page>
        // )
      }
      {/* Render Water Quality Data page with fallbacks for optional data */}
      {svgData && svgData.length > 0 && (
        <Page size='A4' object-fit='fill' style={styles.page} >
          <HeaderSection version={project_details} fixed />
          <View style={styles.body}>
            <DisplayArgoTables
              svgData={svgData.slice(3, 1000) || []} // Pass the remaining items of svgData to DisplayArgoTables
            />
          </View>
          <FooterSection version={project_details} fixed />
        </Page>
      )}
    </Document>
  );
};

export default ArgoReport;
